import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { catchHttpError } from '@trade-platform/ui-shared';
import {
    OrderSigningMethodAction,
    OrderSigningMethodActionTypes,
    OrderSigningMethodFailureAction,
    OrderSigningMethodSuccessAction
} from './actions';
import { OrderSigningMethodService } from './service';

@Injectable()
export class OrderSigningMethodEffects {
    private actions$ = inject(Actions);
    private service = inject(OrderSigningMethodService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderSigningMethod$ = createEffect(() =>
        this.actions$.pipe(
            ofType<OrderSigningMethodAction>(OrderSigningMethodActionTypes.ORDER_SIGNING_METHOD),
            switchMap(action =>
                this.service.orderSigningMethod(action.payload).pipe(
                    map(res => new OrderSigningMethodSuccessAction(res)),
                    catchHttpError(error => of(new OrderSigningMethodFailureAction({ error })))
                )
            )
        )
    );
}
